import {
    Component
} from '@angular/core';


@Component({
    selector: 'partial-loader',
    templateUrl: './partial-loader.component.html',
    styleUrls: ['./partial-loader.component.scss']
})
export class PartialLoader {
    constructor() {
        console.log("PartialLoader")
    }

}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/partialLoader/partial-loader.component.ts